var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74652 2.95146C7.65931 2.85305 6.38348 2.87956 4.69866 3.00275C3.54041 3.08743 2.68124 4.02267 2.55948 5.12323C2.07216 9.52809 1.90624 12.9331 2.41979 17.3994C2.50905 18.1757 2.81294 18.8716 3.26609 19.4357C3.92225 20.2527 4.88564 20.7873 5.94904 20.9076C8.82071 21.2323 13.8944 21.092 16.5813 20.9856C18.0623 20.9269 19.3752 19.9961 19.8633 18.5844C19.9226 18.4129 19.9852 18.2334 20.0502 18.0471C20.6456 16.3394 21.4465 14.0422 21.8579 11.7852C22.0798 10.5685 21.2583 9.53017 20.1619 9.27631V7.97994C20.1619 6.69783 19.1068 5.68863 17.8426 5.68863H12.5951C12.3738 5.68074 12.1855 5.53963 12.1155 5.34317L11.8066 4.47694C11.4944 3.60149 10.6824 2.9956 9.74652 2.95146ZM6.14968 19.1331C5.73468 19.0863 5.34938 18.9269 5.03189 18.6829L8.03983 12.0865L8.04245 12.0808C8.32305 11.4536 8.92616 11.0227 9.62278 10.9694C10.8949 10.8721 12.6727 10.7618 14.1836 10.7618C15.8799 10.7618 18.1923 10.9005 19.679 11.004C19.9992 11.0263 20.1359 11.2747 20.1012 11.4649C19.7163 13.576 18.9626 15.74 18.3626 17.4627L18.3623 17.4637C18.298 17.648 18.2356 17.8273 18.1756 18.0007C17.938 18.688 17.2885 19.1704 16.5106 19.2013C13.7918 19.309 8.86069 19.4397 6.14968 19.1331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFolder);
export default __webpack_public_path__ + "static/media/Open-Folder.cfaded66.svg";
export { ForwardRef as ReactComponent };